/* Newsletter pop-up and reminder. The pop-up waits its turn: never over the
   privacy banner, a flyout, the phone menu or another dialog, never on the
   bag page, and never again once someone has subscribed. */
(function () {
  'use strict';
  if (window.__meridianNewsletter) return;
  window.__meridianNewsletter = true;

  var KEY = 'meridian:newsletter';        // { state: 'subscribed' | 'dismissed', at, reminder }
  var CONTEXT = 'meridian:newsletter-form'; // which form was just submitted
  var DAY = 864e5;

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  // Remember which sign-up form was used, so the result shows in the right place.
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-newsletter-form]');
    if (f) { try { sessionStorage.setItem(CONTEXT, f.getAttribute('data-newsletter-form')); } catch (err) {} }
  }, true);

  function busyElsewhere() {
    var root = document.documentElement;
    if (root.classList.contains('has-flyout') || root.classList.contains('mnav-open')) return true;
    if (document.querySelector('dialog[open]:not([data-newsletter-popup])')) return true;
    // Shopify's privacy banner is position: fixed, so offsetParent is always
    // null for it; measure what is actually on screen instead.
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    var style = window.getComputedStyle(banner);
    var box = banner.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && box.height > 0 && box.bottom > 0;
  }

  function init() {
    var dialog = document.querySelector('[data-newsletter-popup]');
    var reminder = document.querySelector('[data-newsletter-reminder]');
    var submitted = null;
    try { submitted = sessionStorage.getItem(CONTEXT); sessionStorage.removeItem(CONTEXT); } catch (e) {}

    // Back from a submission: record a success, and keep the result with its form.
    if (submitted) {
      var posted = /[?&]customer_posted=true/.test(window.location.search);
      if (posted) write({ state: 'subscribed', at: Date.now() });
      document.querySelectorAll('[data-newsletter-form]').forEach(function (f) {
        var status = f.querySelector('[data-nl-status]');
        if (status && f.getAttribute('data-newsletter-form') !== submitted) status.hidden = true;
      });
    }
    if (!dialog) return;

    var days = parseInt(dialog.dataset.days, 10) || 7;
    var delay = (parseInt(dialog.dataset.delay, 10) || 0) * 1000;
    var sectionId = dialog.dataset.sectionId;

    function showReminder() {
      var s = read();
      if (reminder && s.state !== 'subscribed' && s.reminder !== false) reminder.hidden = false;
    }
    function open() {
      if (dialog.open) return;
      if (reminder) reminder.hidden = true;
      dialog.showModal();
      var ok = dialog.querySelector('.nlform__ok');
      if (ok) ok.focus();
    }
    // Record the dismissal from each way out directly, rather than relying on
    // the dialog's close event alone.
    function dismissed() {
      var s = read();
      if (s.state === 'subscribed') return;
      write({ state: 'dismissed', at: Date.now(), reminder: s.reminder });
      showReminder();
    }
    function shut() { if (dialog.open) dialog.close(); dismissed(); }
    dialog.addEventListener('close', dismissed);
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); shut(); });
    var closeBtn = dialog.querySelector('.modal__close');
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); shut(); });
    // A click on the backdrop lands on the dialog element itself.
    dialog.addEventListener('click', function (e) { if (e.target === dialog) shut(); });

    if (reminder) {
      reminder.querySelector('[data-nl-open]').addEventListener('click', open);
      reminder.querySelector('[data-nl-dismiss]').addEventListener('click', function () {
        reminder.hidden = true;
        var s = read();
        write({ state: s.state || 'dismissed', at: s.at || Date.now(), reminder: false });
      });

      /* Apple's only floating control is a 35px chat avatar tucked in the corner.
         This pill is 325px wide, so it steps aside rather than resting on
         content: while the footer or the newsletter band reaches the strip it
         sits in, it is tucked away. Measured on scroll, not with an
         IntersectionObserver, which embedded viewers do not fire reliably, and
         scheduled on whichever comes first of a frame or a short timer, because
         a hidden viewer never runs requestAnimationFrame and the check would
         otherwise stall after the first scroll. */
      var blockers = document.querySelectorAll('footer.ftr, .nl-band');
      var STRIP = 70; // 20px offset + 38px pill + 12px clearance
      var ticking = false;
      function tuck() {
        if (!ticking) return;
        ticking = false;
        var limit = window.innerHeight - STRIP;
        var covered = Array.prototype.some.call(blockers, function (el) {
          var r = el.getBoundingClientRect();
          return r.top < limit && r.bottom > 0;
        });
        reminder.dataset.tucked = covered ? 'true' : 'false';
      }
      function schedule() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(tuck);
        setTimeout(tuck, 100);
      }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      schedule();
    }

    // Theme editor: show it while the section is selected, never on a timer.
    document.addEventListener('shopify:section:select', function (e) { if (e.detail.sectionId === sectionId) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.detail.sectionId === sectionId && dialog.open) dialog.close(); });
    if (window.Shopify && window.Shopify.designMode) return;

    if (submitted === 'popup') { open(); return; }

    var state = read();
    if (state.state === 'subscribed') return;
    if (state.state === 'dismissed' && Date.now() - (state.at || 0) < days * DAY) { showReminder(); return; }
    if (dialog.dataset.enabled !== 'true' || document.body.classList.contains('template-cart')) return;

    var tries = 0;
    function attempt() {
      if (busyElsewhere() && tries++ < 60) { setTimeout(attempt, 2000); return; }
      open();
    }
    setTimeout(attempt, delay);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
